import { Any, Arr, Locale } from "@kizmann/pico-js";

export default {

    name: 'AppHeader',

    inject: {
        CrudIndex: {
            default: undefined
        }
    },

    props: {

        title: {
            default()
            {
                return '';
            },
            type: [String]
        },

        search: {
            default()
            {
                return '';
            },
            type: [String]
        },

        placeholder: {
            default()
            {
                return Locale.trans('Your search ...');
            },
            type: [String]
        }

    },

    renderTitle()
    {
        if ( Any.isEmpty(this.title) ) {
            return null;
        }

        return (
            <div class="app-header__title">
                <h1>{this.title}</h1>
            </div>
        );
    },

    renderFooter()
    {
        let ctors = [
            'renderSearch',
            'renderFilter',
            'renderAction'
        ];

        return (
            <div class="app-header__footer">
                {Arr.each(ctors, (fx) => this.ctor(fx)())}
            </div>
        );
    },

    renderFilter()
    {
        if ( ! this.$slots.filter ) {
            return null;
        }

        return (
            <div class="app-header__filter">
                {this.$slots.filter()}
            </div>
        );
    },

    renderAction()
    {
        if ( ! this.$slots.action ) {
            return null;
        }

        return (
            <div class="app-header__action">
                {this.$slots.action()}
            </div>
        );
    },

    renderSearch()
    {
        if ( ! this.CrudIndex ) {
            return null;
        }

        let inputProps = {
            modelValue: this.search, placeholder: this.placeholder, icon: 'fa fa-times'
        };

        if ( Any.isEmpty(this.search) ) {
            inputProps.iconDisabled = true;
        }

        inputProps['onIconClick'] = () => {
            this.$emit('update:search', '');
        }

        inputProps['onUpdate:modelValue'] = (value) => {
            this.$emit('update:search', value);
        };

        return (
            <div class="app-header__search">
                <NInput {...inputProps} />
            </div>
        );
    },

    render()
    {
        let ctors = [
            'renderTitle',
            'renderFooter'
        ];

        let classList = [
            'app-header'
        ];

        if ( this.CrudIndex ) {
            classList.push('is-index');
        }

        return (
            <div class={classList}>
                {Arr.each(ctors, (fx) => this.ctor(fx)())}
            </div>
        );
    }
}